<template>
  <div class="cmp-wrapper">
    <basic-container>
      <mc-message-list />
    </basic-container>
  </div>
</template>


<script>
import McMessageList from "./../../../blocks/mc-message-list/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    McMessageList
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
